export function sendMessage(msg: string) {
  const startBtn = document.getElementById('cobrowse-start-btn-1')
  if (startBtn) startBtn.click()

  setTimeout(() => {
    const chatInput = document.getElementById('cobrowse-chat-input')
    if (!(chatInput instanceof HTMLInputElement) && !(chatInput instanceof HTMLTextAreaElement))
      return
    chatInput.value = msg
  }, 100)

  setTimeout(() => {
    const chatSend = document.getElementById('cobrowse-chat-send')
    if (chatSend) chatSend.click()
  }, 1000)
}
